export const R = {
	"EditMyInformationLabelA11y": "Edit my information. Click to open a modal where you can edit email address and phone number",
	"Name": "Name",
	"Phone": "Phone",
	"Email": "Email",
	"Edit": "Edit",
	"Save": "Save",
	"InvalidCpr": "Please enter a valid CPR number (10 digits).",
	"InvalidEmail": "Please enter a valid email address.",
	"NetworkError": "There was an error. Please try again. {0}",
	"ErrorInvitePartner": "Could not invite the family member. ",
	"PartnerEmailRequired": "The household member's email is required",
	"PartnerNameRequired": "The household member's full name is required",
	"PartnerCprRequired": "The household member's CPR number is required",
	"Active": "Active",
	"Invited": "Invited",
	"NoPartner": "No partner",
	"AlreadyHasPartner": "The patient already has a partner",
	"InvitePartner": "Invite family member",
	"OpenDeleteHouseholdMemberModalA11y": "Remove household member. Click to open a modal for confirmation of removal",
	"OpenEditPetModalA11y": "Edit pet. Click to open a modal where you can edit your pet's information.",
	"OpenDeletePetModalA11y": "Remove pet. Click to open a modal for confirmation of removal",
	"AddPet": "Add pet",
	"EditPet": "Edit pet",
	"PetName": "Name of pet",
	"PetSex": "Sex and status",
	"PetRace": "Breed (optional)",
	"PetRacePlaceholder": "e.g. labrador",
	"PetBirthdate": "Birthmonth and year",
	"PetBirthdateHint": "Are you in doubt? Your best guess is fine.",
	"PetType": "Type of pet",
	"PetWeight": "Weight in kilograms (optional)",
	"PetWeightPlaceholder": "e.g. 5.2 or 5,2",
	"MonthJanuary": "January",
	"MonthFebruary": "February",
	"MonthMay": "May",
	"MonthMarch": "March",
	"MonthApril": "April",
	"MonthJune": "June",
	"MonthJuly": "July",
	"MonthAugust": "August",
	"MonthSeptember": "September",
	"MonthOctober": "October",
	"MonthNovember": "November",
	"MonthDecember": "December",
	"SelectMonth": "Select month",
	"SelectYear": "Select year",
	"PetSexMale": "Male",
	"PetSexFemale": "Female",
	"PetSexMaleNeutered": "Male neutered",
	"PetSexFemaleSterilized": "Female sterilized",
	"PetSexUnknown": "Unknown",
	"PetTypeDog": "Dog",
	"PetTypeCat": "Cat",
	"PetTypeRabbit": "Rabbit",
	"PetTypeRodent": "Rodent",
	"SelectPetType": "Select pet type",
	"SelectPetSex": "Select pet sex",
	"ConfirmAddPet": "Save",
	"ConfirmEditPet": "Update",
	"PleaseEnterPetName": "Please enter the name of your pet",
	"PleaseSelectPetType": "Please select pet type",
	"PleaseSelectPetSex": "Please select sex",
	"PleaseChoosePetAge": "Please select the birthdate of your pet. It does not need to be 100% accurate.",
	"PleaseSelectMonth": "Please select month",
	"PleaseSelectYear": "Please select year",
	"RemovePet": "Remove pet",
	"RemovePetText": "Are you sure you want to remove your pet?",
	"KeepPet": "Keep pet",
	"ErrorAddPet": "Could not create pet.",
	"ErrorEditPet": "Could not edit pet.",
	"ErrorDeletePet": "Could not remove the pet.",
	"RemovePartner": "Remove household member",
	"RemovePartnerText": "Are you sure you want to remove the link to your household member? Your household member will still be able to access their Hejdoktor profile, but your shared access will be revoked.",
	"KeepHouseholdMember": "Keep link",
	"RemoveHouseholdMember": "Remove link",
	"Partner": "partner",
	"RemoveAccess": "Yes, remove link",
	"ErrorDeletePartner": "Could not remove household member",
	"Profile_Description_Children": "You can contact us on behalf of your minor children. Register them with their CPR number and name here.",
	"Profile_AddChild": "Add child",
	"OpenEditChildModalA11y": "Edit child. Click to open a modal where you can edit your child's information.",
	"OpenDeleteChildModalA11y": "Remove child. Click to open a modal for confirmation of removal",
	"FullName": "Full name",
	"CprNumber": "CPR Number",
	"ProfileConfirmAddKid": "Save",
	"ProfileConfirmEditKid": "Save",
	"Profile_EditChild": "Edit child profile",
	"PleaseEnterFullName": "Please provide your full name",
	"CprPlaceholder": "ddmmyy-xxxx",
	"CprRequired": "Please fill out CPR number",
	"CprTooOld": "Sorry, this functionality is only for children under the age of 18 years. Adults must log in with their own MitID to book a consultation.",
	"DeleteProfile": "Yes, delete profile",
	"RemoveChildText": "Are you sure you want to delete your child's profile? This action will also delete any previous consultations. Please note that if you have ordered a consultation we are obligated to keep your information for at least 10 years.",
	"KeepProfile": "Keep profile",
	"ConfirmCprIsCorrectHeader": "Are you sure the CPR number is correct?",
	"CprModulusCheckWarning": "does not look like a valid CPR number. To be able to record medical information and issue prescriptions, we need the correct CPR number. Therefore, please check that the CPR number is entered correctly.",
	"Back": "Back",
	"ConfirmAndSave": "Confirm and save",
	"RefreshDataError": "Something went wrong with updating the page. Please reload.",
	"RemoveChild": "Remove child",
	"PleaseEnterANumber": "Please enter a number. You may use decimals (e.g. 5,2 or 5.2)"
}